import { Resolver, ValidationMode } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { getCheckoutSchema } from "@/utils/validation/checkoutSchema.ts";

export const formConfig = (checkoutData?: ICheckoutForm) => ({

  resolver: yupResolver(
    getCheckoutSchema(checkoutData)
  ) as Resolver<ICheckoutForm>,

  mode: "all" as keyof ValidationMode,
  defaultValues: {
    checkoutData,
    firstName: checkoutData?.firstName || "",
    lastName: checkoutData?.lastName || "",
    email: checkoutData?.email || "",
    streetAddress: checkoutData?.address || "",
    city: checkoutData?.city || "",
    zipCode: checkoutData?.zipCode || "",
    idCountry: checkoutData?.idCountry || 1,
    idState: checkoutData?.idState || 1,
    phoneNumber: checkoutData?.phoneNumber || "",
    shippingMethod: "",
    paymentMethodId: checkoutData?.paymentMethodId || "",

    billingFirstName: checkoutData?.firstName || "",
    billingLastName: checkoutData?.lastName || "",
    billingStreetAddress: checkoutData?.address || "",
    billingCity: checkoutData?.city || "",
    billingZipCode: checkoutData?.zipCode || "",
    billingIdCountry: checkoutData?.idCountry || 1,
    billingIdState: checkoutData?.idState || 1,
    billingPhoneNumber: checkoutData?.phoneNumber || "",
    billingEmail: checkoutData?.email || "",
    billingAddress: true,

    number: "",
    expiry: "",
    cvc: "",
    cardholder: "",
  },
});
